import React from 'react';
import './Standings.css';

function Standings({ teams = [], showLeagueName = false, title = "Standings", onDragStart }) {
  if (!teams.length) return <p>No teams found.</p>;

  const sorted = teams
    .map(team => ({
      ...team,
      winPercentage:
        team.wins + team.losses > 0
          ? (team.wins / (team.wins + team.losses)).toFixed(3)
          : '0.000',
    }))
    .sort((a, b) => {
      const aWinPct = parseFloat(a.winPercentage);
      const bWinPct = parseFloat(b.winPercentage);
      if (bWinPct !== aWinPct) return bWinPct - aWinPct;
      return a.losses - b.losses || b.wins - a.wins;
    });

  return (
    <div className="fab-standings-container">
      <h2 className="fab-standings-title">{title}</h2>
      <table className="fab-standings-table">
        <thead>
          <tr>
            <th>Pos</th>
            <th>Team</th>
            {showLeagueName && <th>League</th>}
            <th>W</th>
            <th>L</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((team, index) => (
            <tr
              key={team.id}
              draggable
              onDragStart={(e) => {
                e.dataTransfer.setData("application/json", JSON.stringify(team));
              }}


              className="draggable-row"
            >
              <td>{index + 1}</td>
              <td>{team.name}</td>
              {showLeagueName && <td>{team.leagueName}</td>}
              <td>{team.wins}</td>
              <td>{team.losses}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Standings;
